import {reactive, toRefs, provide, inject} from "@vue/composition-api";
import {$t} from "../../i18n";

export const state = reactive({
    //GENERIC DIALOG
    dialogs: [],
    dialog_open: false,
    dialog_width: 500,
    dialog_component: () => {},
    dialog_payload: {},
    dialog_action: null,
    dialog_close_action: null,
    //CONFIRM DIALOG
    confirm_open: false,
    confirm_options: {
        title: "",
        text: "",
        options: null,
        action: null,
        action2: null,
        cancel: null,
        confirm_text: "",
        confirm_text2: "",
        cancel_text: "",
        width: 500,
        icon: "",
        action_tooltip: null,
        class_name: "",
        warning_text: ""
    },
    //SNACKBAR DIALOG
    snackbar_open: false,
    snackbar_options: {
        text: "",
        close_text: "",
        timeout: 3000,
        color: "error",
        text_color: "white",
        show_icon: false,
        icon: "",
        icon_color: ""
    },
    //ERROR DIALOG
    error_open: false,
    error_options: {
        title: "",
        text: "",
        action: null,
        confirm_text: "",
        cancel_text: "",
        width: 300
    }
});

export const actions = {
    setDialogOptions({ width = 500, component = () => {}, payload = {}, action = null, close_action = null } = {}) {
        const existingComponent = state.dialogs.find(dialog => dialog.component.toString() === component.toString())

        if (existingComponent) return

        state.dialogs.push({ width , component , payload , action, close_action })

    },
    setConfirmOptions({
                          title = "",
                          text = "",
                          options = null,
                          confirm_text = "",
                          confirm_text2 = "",
                          action_tooltip = null,
                          class_name = "",
                          cancel_text = "",
                          width = 500,
                          action = () => actions.closeConfirmDialog(),
                          action2 = null,
                          cancel = null,
                          icon = "",
                          warning_text = ""
                      } = {}) {
        state.confirm_options = {
            title,
            text,
            options,
            action,
            action2,
            cancel,
            confirm_text,
            confirm_text2,
            cancel_text,
            width,
            icon,
            action_tooltip,
            class_name,
            warning_text
        };
    },
    setSnackBarOptions({
                           text = "text",
                           close_text = $t("Close"),
                           color = "text_secondary",
                           text_color = "white",
                           show_icon = false,
                           icon = "",
                           icon_color = "",
                           action = null,
                           action_text = null,
                           timeout = 3000
                       } = {}) {
        state.snackbar_options = {
            text,
            close_text,
            color,
            text_color,
            action,
            action_text,
            timeout,
            show_icon,
            icon,
            icon_color
        };
    },
    setErrorOptions({title, text, action, confirm_text, cancel_text, width} = {}) {
        state.error_options = Object.assign({}, {title, text, action, confirm_text, cancel_text, width});
    },

    openDialog() {
        state.dialog_open = true;
    },
    closeDialog() {
        state.dialogs.pop()
    },
    openConfirmDialog() {
        state.confirm_open = true;
    },
    closeConfirmDialog() {
        state.confirm_open = false;
    },
    openSnackBar() {
        state.snackbar_open = true;
    },
    closeSnackBar() {
        state.snackbar_open = false;
    },
    openError() {
        state.error_open = true;
    },
    closeError() {
        state.error_open = false;
    },
    setSnackBar(val) {
        state.snackbar_open = val;
    },
    setConfirmDialog(val) {
        state.confirm_open = val;
    },
    setDialog(val) {
        state.dialog_open = val;
    },
    setError(val) {
        state.error_open = val;
    },
    setDialogAction(func) {
        state.dialog_action = func
    }
};
export const getters = {};

export const key = Symbol("DialogModule");

export const provideDialog = () => {
    provide(key, {
        ...toRefs(state),
        ...getters,
        ...actions
    });
};

export default () => inject(key);
